var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_182",
    "data-name": "Gruppe 182",
    transform: "translate(-9 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_295",
    "data-name": "Pfad 295",
    d: "M36,12H29V7H19v5H9v2h3V41H36V14h3V12ZM21,9h6v3H21ZM34,39H14V14H34Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_296",
    "data-name": "Pfad 296",
    d: "M23,18V35h2V18H23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_297",
    "data-name": "Pfad 297",
    d: "M18,18V35h2V18H18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_298",
    "data-name": "Pfad 298",
    d: "M28,18V35h2V18H28Z",
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Delete_icon.96e15dd29ee65e9277606fe6fde85484.svg";